
<div class="empty-state">
  <div class="content">
    <icon v-if="icon" :name="icon" />

    <h3 v-if="title">{{ title }}</h3>

    <p v-if="description">{{ description }}</p>

    <slot />
  </div>
</div>
